import React from "react";
import { Typography } from "antd";

const { Text } = Typography;

const UIText = ({
  children,
  type,
  level,
  style,
  className,
  ellipsis,
  onClick,
}) => {
  return (
    <Text
      type={type}
      style={style}
      className={level ? `f-size-${level}` : className}
      ellipsis={ellipsis}
      onClick={onClick}
    >
      {children}
    </Text>
  );
};

export default UIText;
